import React from 'react';
import './CSS/Contact.css';
import ContactVideo from '../Components/Assets/OutdoorFirepit.mp4'; // You can replace this with a new video
import ContactImage from '../Components/Assets/About-bg.jpg'; // Add any relevant image

const Contact = () => {
    return (
        <div className="contact-wrapper">
            {/* Video background */}
            <video className="contact-video" autoPlay loop muted>
                <source src={ContactVideo} type="video/mp4" />
            </video>

            {/* Contact Information Container */}
            <div className="contact-content">
                <div className="contact-info">
                    <h1>Contact Us</h1>
                    <p>We'd love to hear from you! Reach out to us for inquiries, feedback, or assistance.</p>
                    <form className="contact-form">
                    <div className="form-group">
                        <label htmlFor="name">Name</label>
                        <input type="text" id="name" name="name" placeholder="Your Name" required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input type="email" id="email" name="email" placeholder="Your Email" required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="message">Message</label>
                        <textarea id="message" name="message" placeholder="Your Message" rows="5" required></textarea>
                    </div>
                    <button type="submit" className="contact-btn">Send Message</button>
                </form>
                </div>
            </div>



        </div>
    );
};

export default Contact;
